import type { FC } from 'react';
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import React from 'react';
import QuoteAddonWizardRightPreview from './QuoteAddonWizardRightPreview';
import { hasAddons } from '../../../app/utils';

interface QuoteAddonWizardAddonsSelectedProps {
  className?: string;
  addons?: QuoteLineItem[];
  onRemoveAddon: (addon: QuoteLineItem) => void;
}

const QuoteAddonWizardAddonsSelected: FC<QuoteAddonWizardAddonsSelectedProps> = ({
  addons,
  onRemoveAddon
}) => {

  if (!hasAddons(addons)) {
    return null;
  }

  const addonView = function (addon: QuoteLineItem) {

    if (!addon) {
      return null;
    }

    return <QuoteAddonWizardRightPreview
      key={addon.name + 'right-preview'}
      image={addon.imageUrl}
      name={addon.name}
      addon={addon}
      onRemoveAddon={onRemoveAddon}
    />;
  };

  return <React.Fragment>
    {addons!
    .filter((v) => v.selected)
    .map((li) => addonView(li))}
  </React.Fragment>
};

export default QuoteAddonWizardAddonsSelected;